import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS
import 'ag-grid-enterprise';

import '../../styles/css/AgGrid.css';

import { useEffect, useMemo, useRef, useState } from 'react';
import { Row } from 'react-bootstrap';

import withTranslations from '../../utils/HighOrderComponent';
import AgGridHeader from './Layout/AgGridHeader';
import AgGridTable from './Layout/AgGridTable';

const AgGrid = (props) => {
  const gridRef = useRef(null);
  const {
      t,
      type,
      collapseSearch = false,
      inForm = false,
      additionalFilterCriteria,
      additionalProps,
      rowsList,
      initialSelectedNodes,
      singleSelect = false,
      setAgGridType,
      buttonsTranslation,
      customHeaderComponent,
      showAttributeView = true,
      initialSearch,
    } = props || {},
    { Tables } = t || {};

  const [rowsChecked, setRowsChecked] = useState([]);
  const [filterActive, setFilterActive] = useState(false);
  const [action, setAction] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const tableTitle = useMemo(
    () => (type && Tables[type] && Tables[type]) || '',
    [Tables, type]
  );

  useEffect(() => {
    setRowsChecked([]);
    setFilterActive(false);
  }, [type]);

  useEffect(() => {
    if (rowsList.length > 0 && initialSelectedNodes?.length > 0) {
      gridRef.current?.api?.forEachNode((node) => {
        if (
          initialSelectedNodes?.some(
            (selectedNode) => selectedNode.id === node.data.id
          )
        ) {
          node.setSelected(true);
        }
      });
      setRowsChecked(initialSelectedNodes);
    }
  }, [rowsList, gridRef, initialSelectedNodes]);

  useEffect(() => {
    if (rowsList?.length > 0) {
      const selectedList = rowsChecked.filter((rowOfSelectedList) => {
        return rowsList.find((row) => row.id === rowOfSelectedList.id);
      });
      setRowsChecked(selectedList);
    } else {
      setRowsChecked([]);
    }
    // eslint-disable-next-line
  }, [rowsList]);

  const onSelectionChangeHandler = (params) => {
    const selectedNodes = Object.values(
      params?.api?.selectionService.selectedNodes
    );

    if (singleSelect && selectedNodes?.filter((node) => node)?.length > 1) {
      gridRef.current?.api?.deselectAll();
      return;
    }
    const filteredSelected = selectedNodes?.filter((v) => !!v && v.displayed);

    if (filteredSelected?.length > 0) {
      setRowsChecked(filteredSelected?.map((node) => node.data));
    } else setRowsChecked([]);
  };

  const onFilterModifiedHandler = (params) => {
    if (params?.api?.filterManager?.activeColumnFilters?.length > 0) {
      !filterActive && setFilterActive(true);
    } else filterActive && setFilterActive(false);
  };

  return (
    <Row className="wrapper-fade-in">
      <AgGridHeader
        {...props}
        gridRef={gridRef}
        showAttributeView={showAttributeView}
        tableTitle={tableTitle}
        rowsChecked={rowsChecked}
        filterActive={filterActive}
        action={action}
        setAction={setAction}
        collapseSearch={collapseSearch}
        inForm={inForm}
        initialSearch={initialSearch}
        type={type}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        additionalFilterCriteria={additionalFilterCriteria}
        setFilterActive={setFilterActive}
        additionalProps={additionalProps}
        setRowsChecked={setRowsChecked}
        setAgGridType={setAgGridType}
        buttonsTranslation={buttonsTranslation}
        customHeaderComponent={customHeaderComponent}
      />
      <AgGridTable
        {...props}
        gridRef={gridRef}
        onSelectionChange={onSelectionChangeHandler}
        onFilterModified={onFilterModifiedHandler}
        setAction={setAction}
        tableTitle={tableTitle}
        inForm={inForm}
        setSelectedRow={setSelectedRow}
        setRowsChecked={setRowsChecked}
      />
    </Row>
  );
};

export default withTranslations(AgGrid, 'AgGridPage');
